import { InterimStates } from "../../components/Protected/InterimStates";

import { Dropdown } from 'semantic-ui-react'

interface IProps {
    tags: any,
    refetchParent: any,
    loading: any,
    error: any,
    data: any,
    updateTags: any,
    payload: any,
}

const TagsPicker = ({
    tags,
    refetchParent,
    loading,
    error,
    data,
    updateTags,
    payload,
}: IProps) => {
    if (loading || error) {
        return <InterimStates loading={loading} error={error} label='tags' />
    }

    const handleChange = async (_: any, data: any) => {
        await updateTags({
            variables: {
                ...payload,
                tagIds: data.value
            }
        });

        refetchParent();
    };

    const tagOptions = data.tags.map((p: any) => ({
        key: p.id,
        text: p.name,
        value: p.id,
    }));

    return (
        <Dropdown
            placeholder='Tags'
            fluid
            multiple
            value={(tags || []).map((p: any) => p.id)}
            onChange={handleChange}
            search
            selection
            options={tagOptions}
        />
    )
}

export { TagsPicker }
